import React from 'react';

const Main = ({ error }) => {
    return <div>
        {error.status !== 500 && <div>
            <div style={{
                border: '1px solid #ffddd9', backgroundColor: '#ffddd9', borderRadius: 3,
                color: '#cc3833', textAlign: 'center', fontSize: 14, paddingTop: 10, paddingBottom: 10
            }}>
                {error.data.message ? error.data.message : error.data}
            </div>
        </div>}
        {error.status === 500 && <div>
            <div style={{
                border: '1px solid #ffddd9', backgroundColor: '#ffddd9', borderRadius: 3,
                color: '#cc3833', textAlign: 'center', fontSize: 14, paddingTop: 10, paddingBottom: 10
            }}>
                Internal Server Error
            </div>
        </div>}
    </div>
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/ErrorPanel.js